import { z } from 'zod/v4';

// `id` is the shop id a brand's webshop embeds (e.g. `shop.example.com`), so a
// slash would make it unaddressable as the `:id` URL segment of the other admin
// webshop routes.
export const AdminCreateWebshopBodySchema = z.object({
  id: z
    .string()
    .min(1)
    .max(255)
    .regex(/^(?!.*\/.*$)/),
  name: z.string().max(255).nullish(),
  shopPlatform: z.string().max(255).nullish(),
  companyId: z.string().max(255).nullish(),
  isBlocked: z.number().nullish(),
});

export type AdminCreateWebshopBody = z.infer<
  typeof AdminCreateWebshopBodySchema
>;

// The webshop row create, read-one and update answer with, inside the platform's
// `{ data, metadata }` envelope (legacy sent it bare).
// Legacy answered `SELECT *`; this keeps the columns the admin screens read
// plus the unscoped audit columns, and leaves out the impersonate / api-key
// ones no consumer reads.
export const AdminWebshopSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  companyId: z.string().nullable(),
  shopPlatform: z.string().nullable(),
  isBlocked: z.number().nullable(),
  connectedOrigins: z.string().nullable(),
  createdAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  createdByCompanyId: z.string().nullable(),
  updatedAt: z.coerce.date().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByUserName: z.string().nullable(),
  updatedByCompanyId: z.string().nullable(),
  updatedByCompanyName: z.string().nullable(),
});

export type AdminWebshop = z.infer<typeof AdminWebshopSchema>;
